import { render } from "./TestButton.vue?vue&type=template&id=3b7593d1&scoped=true"
import script from "./TestButton.vue?vue&type=script&lang=js"
export * from "./TestButton.vue?vue&type=script&lang=js"

import "./TestButton.vue?vue&type=style&index=0&id=3b7593d1&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7593d1"]])

export default __exports__